var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyConfigIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57711 1.64706C7.57711 0.737413 6.8397 0 5.93006 0C5.02041 0 4.283 0.737413 4.283 1.64706V4.28236H1.31765C0.589931 4.28236 0 4.87229 0 5.6V26.6824C0 27.4101 0.589931 28 1.31765 28H18.4471C19.1748 28 19.7647 27.4101 19.7647 26.6824V5.6C19.7647 4.87229 19.1748 4.28236 18.4471 4.28236H15.483V1.64706C15.483 0.737413 14.7456 0 13.8359 0C12.9263 0 12.1889 0.737413 12.1889 1.64706V4.28236H7.57711V1.64706ZM2.96567 11.5294C2.96567 10.6198 3.70308 9.88235 4.61273 9.88235H15.1539C16.0636 9.88235 16.801 10.6198 16.801 11.5294C16.801 12.4391 16.0636 13.1765 15.1539 13.1765H4.61273C3.70308 13.1765 2.96567 12.4391 2.96567 11.5294ZM2.96567 16.8C2.96567 15.8904 3.70308 15.1529 4.61273 15.1529H12.5186C13.4283 15.1529 14.1657 15.8904 14.1657 16.8C14.1657 17.7096 13.4283 18.4471 12.5186 18.4471H4.61273C3.70308 18.4471 2.96567 17.7096 2.96567 16.8ZM2.96567 22.0706C2.96567 21.1609 3.70308 20.4235 4.61273 20.4235H9.88332C10.793 20.4235 11.5304 21.1609 11.5304 22.0706C11.5304 22.9802 10.793 23.7176 9.88332 23.7176H4.61273C3.70308 23.7176 2.96567 22.9802 2.96567 22.0706Z",
    fill: "#1374D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyConfigIconActive);
export default __webpack_public_path__ + "static/media/daily-config-icon-active.9c3e57d2bd2d830817b9e1d57b3be3ee.svg";
export { ForwardRef as ReactComponent };